module.exports = __webpack_public_path__ + "userCenter-achievement-icon1-1beeaf26.png";